/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState} from 'react'
import {Button} from "primereact/button";
import useClipboardImage from "./useClipboardImage";
import InputClipboard from "./InputClipboard";
import InputClipboardFile from "./InputClipboardFile";
import ImageViewer from "../../componentes/imageViewer";
import PdfViewer from "../../componentes/pdfViewer";

const ClipboardImage = ({value, disabled, onChange, height, className, multiple}) => {
    const [visible, setVisible] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);

    const evidencias = value?.evidencias ?? (!value?.isEmpty && value ? [value] : []);
    const isEmpty = evidencias.length === 0;

    const {
        getUrl
    } = useClipboardImage(value, onChange);

    const onAdd = (newValue) => {
        if (!multiple) {
            onChange(newValue);
            return;
        }

        const nuevasEvidencias = [
            ...evidencias,
            newValue
        ];

        onChange({
            ...value,
            evidencias: nuevasEvidencias,
            files: nuevasEvidencias.map(e => e.file).filter(e => e),
            isEmpty: nuevasEvidencias.length === 0
        });
    };

    const onDelete = (index) => {
        if (!multiple) {
            onChange({
                isEmpty: true
            });
            return;
        }

        const nuevasEvidencias = evidencias.filter((_, i) => i !== index);

        onChange({
            ...value,
            evidencias: nuevasEvidencias,
            files: nuevasEvidencias.map(e => e.file).filter(e => e),
            isEmpty: nuevasEvidencias.length === 0
        });
    };

    const onPreview = (evidencia) => {
        setSelectedValue(evidencia);
        setVisible(true);
    };

    const selectedIsPdf = selectedValue?.extension?.toLocaleString() === 'pdf';

    return (
        <>
            <div className={`clipboard-image ${className}`}>
                {!disabled &&
                    <>
                        <InputClipboard onChange={onAdd}/>
                        <InputClipboardFile onChange={onAdd}/>
                    </>
                }

                {!isEmpty && evidencias.map((evidencia, index) => {
                    const isPdf = evidencia?.extension?.toLocaleString() === 'pdf';

                    return (
                        <React.Fragment key={index}>
                            {isPdf ?
                                <Button className="p-button-rounded p-button-text" icon="pi pi-eye"
                                        title={'Vista previa'}
                                        onClick={() => onPreview(evidencia)}/>
                                :
                                <img alt="Imagen" src={getUrl(evidencia)} height={height ?? 35} style={{cursor: "pointer"}}
                                     onClick={() => onPreview(evidencia)}/>
                            }

                            {!disabled &&
                                <Button className="p-button-rounded p-button-text" icon="pi pi-trash"
                                        onClick={() => onDelete(index)}/>
                            }
                        </React.Fragment>
                    )
                })}
            </div>

            <ImageViewer value={selectedValue} visible={visible && !selectedIsPdf} hide={() => setVisible(false)}/>
            <PdfViewer value={selectedValue} urlApi={selectedValue?.url} visible={visible && selectedIsPdf} hide={() => setVisible(false)}/>
        </>
    )
}

export default ClipboardImage;